import React, { Component } from 'react';
import { connect } from 'react-redux';

const displayTagTreeValues = (props) => {
    const values = [];
    props.ids.forEach(id => {
        if(props.list[id]) {
            values.push(props.list[id].name);
        }
    });
    return values.join('; ');
}

const mapStateToProps = (state) => {
    return {
        list: state.tags.treeList
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {

    }
}

export const DisplayTagTreeValues = connect(mapStateToProps, mapDispatchToProps)(displayTagTreeValues);
